import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiResponse } from '@core/interface/api-response.interface';
import { PageableResponse } from '@core/interface/pageable.interface';
import { RefId } from '@core/interface/ref-id.interface';
import { UrlBuilder } from '@core/model/url-builder';
import { CreateUserPersonRequestDto } from '@domain/user-person/dtos/create-user-person.request.dto';
import { GetUserPersonRequestDto } from '@domain/user-person/dtos/get-user-person.request.dto';
import { ListUserPersonRequestDto } from '@domain/user-person/dtos/list-user-person.request.dto';
import { UpdateStateUserPersonRequestDto } from '@domain/user-person/dtos/update-state-user-person.request.dto';
import { UpdateUserPersonRequestDto } from '@domain/user-person/dtos/update-user-person.request.dto';
import { UpdatePinUserPersonRequestDto } from '@domain/user-person/dtos/update-pin-user-person.request.dto';
import { UserPersonResponseDto } from '@domain/user-person/dtos/user-person.response.dto';

@Injectable({
  providedIn: 'root',
})
export class UserPersonService extends UrlBuilder {
  constructor(private http: HttpClient) {
    super('user/person');
  }
  create(request: CreateUserPersonRequestDto) {
    const queryUrl = `${this.getApiUrl()}`;
    return this.http.post<ApiResponse<UserPersonResponseDto>>(
      queryUrl,
      request,
    );
  }

  update(request: UpdateUserPersonRequestDto) {
    const { refId } = request;
    const queryUrl = `${this.getApiUrl()}/${refId}`;
    return this.http.put<ApiResponse<UserPersonResponseDto>>(queryUrl, request);
  }

  updateState(request: UpdateStateUserPersonRequestDto) {
    const { refId } = request;
    const queryUrl = `${this.getApiUrl()}/${refId}/state`;
    return this.http.patch<ApiResponse<UserPersonResponseDto>>(
      queryUrl,
      request,
    );
  }

  updatePin(request: UpdatePinUserPersonRequestDto) {
    const { refId } = request;
    const queryUrl = `${this.getApiUrl()}/${refId}/pin`;
    return this.http.patch<ApiResponse<UserPersonResponseDto>>(
      queryUrl,
      request,
    );
  }

  show(request: RefId) {
    const { refId } = request;
    const queryUrl = `${this.getApiUrl()}/show/${refId}`;
    return this.http.get<ApiResponse<UserPersonResponseDto>>(queryUrl, {});
  }

  get(request: GetUserPersonRequestDto) {
    const queryUrl = `${this.getApiUrl()}/get`;
    return this.http.get<ApiResponse<UserPersonResponseDto[]>>(queryUrl, {
      params: { ...request },
    });
  }

  list(request: ListUserPersonRequestDto) {
    const queryUrl = `${this.getApiUrl()}/list`;
    return this.http.get<ApiResponse<PageableResponse<UserPersonResponseDto>>>(
      queryUrl,
      { params: { ...request } },
    );
  }
}
